import { render } from "./PagamentiDataTable.vue?vue&type=template&id=7ed8cf20&scoped=true"
import script from "./PagamentiDataTable.vue?vue&type=script&lang=js"
export * from "./PagamentiDataTable.vue?vue&type=script&lang=js"

import "./PagamentiDataTable.vue?vue&type=style&index=0&id=7ed8cf20&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed8cf20"]])

export default __exports__